import React, { useState } from "react";
import { Skeleton, Tab, Tabs } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CloseIcon from '@mui/icons-material/Close';
// import "./TheStudentDashboard.css";
import "./TheStudentDashboard.css";
import Speaker from './imageFiles/Speaker.png';
import Ann_icon from './imageFiles/Ann_icon.png';

const AnnouncementModal = ({ announcement, onClose }) => {
  if (!announcement) return null;

  return (
    <div className="announcement-modal" onClick={onClose}>
  <div className="announcement-popup" onClick={e => e.stopPropagation()}>
    <div className="announcement-modal-icon-wrapper">
      <div className="announcement-modal-icon">
        <img src={Ann_icon} alt="Announcement Icon" />
      </div>
    </div>
    <h2 className="announcement-title">{announcement.announcement_title}</h2>
    <div className="announcement-body">
      {announcement.announcement_body}
    </div>

    <div className="announcement-actions">
      <button className="announcement-btn cancel-btn" onClick={onClose}>Close</button>
    </div>
  </div>
</div>

  );
};

const StudentAnnouncements = ({
  allRecentAnnouncements,
  weeklyAnnouncements,
  monthlyAnnouncements,
  student_dashboard_initial_loading,
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const skeletonList = Array(4).fill({});

  const handleAnnouncementClick = (announcement) => {
    setSelectedAnnouncement(announcement);
  };

  const renderAnnouncements = (data) => {
    return data?.map((item, index) => (
      <div 
        className="announcement-row" 
        key={index}
        onClick={() => handleAnnouncementClick(item)}
      >
        <div className="announcement-icon">
          <img src={Speaker} alt="Announcement Icon" />
        </div>
        <div className="announcement-text">
          <p className="stdannouncement-title">
            {item.announcement_title || "Announcement details"}
          </p>
          <p className="announcement-body">
            {item.announcement_body?.length > 70
              ? `${item.announcement_body.substring(0, 70)}...`
              : item.announcement_body || "There are many variations of passages of Lorem Ipsum available"}
          </p>
        </div>
      </div>
    ));
  };

  return (
    <div className="announcement-box">
      <h6 className="announcement-header">Announcements</h6>
      <div className="paper-details-topBar">
        <div>&emsp;</div>
        <Tabs
          value={tabIndex}
          onChange={(e, val) => setTabIndex(val)}
          className="announcement-tabs"
          TabIndicatorProps={{ style: { backgroundColor: "#8D4ED3" } }}
        >
          <Tab label="All" />
          <Tab label="Last month" />
          <Tab label="7 Days" />
        </Tabs>
        <div>&emsp;</div>
      </div>
      {student_dashboard_initial_loading ? (
        <div className="announcement-list">
          {skeletonList.map((_, index) => (
            <div className="announcement-row" key={index}>
              <Skeleton variant="circular" width={30} height={30} />
              <div className="announcement-text">
                <Skeleton variant="text" width={220} height={22} />
                <Skeleton variant="text" width={160} height={18} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="announcement-list">
          {tabIndex === 0 && renderAnnouncements(allRecentAnnouncements)}
          {tabIndex === 1 && renderAnnouncements(monthlyAnnouncements)}
          {tabIndex === 2 && renderAnnouncements(weeklyAnnouncements)}
        </div>
      )}

      {selectedAnnouncement && (
        <AnnouncementModal
          announcement={selectedAnnouncement}
          onClose={() => setSelectedAnnouncement(null)}
        />
      )}
    </div>
  );
};

export default StudentAnnouncements;